// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_lKq","cls2":"TranslationModal-cls2_OdG TranslationModal-cls1_lKq"};